import React, { useState, useEffect } from "react";
import img from "../../blog1.jpg";
import { FaGithub, FaGlobe } from "react-icons/fa";
import { db } from "../../utils/firebase";
import Loading from "../../components/Loading";
const Projects = () => {
	const [loading, setLoading] = useState(true);
	const [projects, setProjects] = useState([]);

	useEffect(() => {
		//fetch the projects
		db.collection("projects")
			.get()
			.then(function(querySnapshot) {
				let projects = [];
				querySnapshot.forEach(function(doc) {
					console.log(doc.id, " => ", doc.data());
					projects.push({ id: doc.id, ...doc.data() });
				});
				setProjects(projects);
				setLoading(false);
			});
	}, []);

	return (
		<div className="projects_wrapper">
			{loading && <Loading />}
			{!loading && (
				<>
					<div className="header">
						<h1>My projects</h1>
					</div>
					<div className="projects">
						{projects.map(
							({ image, title, website, github, tags, id }) => (
								<div className="project" key={id}>
									<img src={image} alt="..." />
									<div className="project_info">
										<h1>{title}</h1>
										<div className="tags">
											{tags.map((tag, i) => (
												<span key={i} className="tag">
													{tag}
												</span>
											))}
										</div>
										<div className="link">
											<a
												href={github}
												target="_blank"
												rel="noopener noreferrer"
											>
												<FaGithub size="30px" />
											</a>
											<a href={website}>
												<FaGlobe
													size="30px"
													target="_blank"
													rel="no opener noreferrer"
												/>
											</a>
										</div>
									</div>
								</div>
							)
						)}
					</div>
				</>
			)}
		</div>
	);
};

export default Projects;
